import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'react-bootstrap';

import { VIDEO_COORDINATE_DATA_TYPES } from '../../../api/Videos/Videos';

const VideoDrawLineField = ({ coordinatesDataType, buttonActive, toggleButtonSwitch }) => {
  if (coordinatesDataType === VIDEO_COORDINATE_DATA_TYPES.LINE) {
    return (
      <Form.Group>
        <Form.Label>Line</Form.Label>
        <Form.Control
          as={Button}
          active={buttonActive}
          onClick={() => toggleButtonSwitch('defineLineActive')}
        >
          Draw Line
        </Form.Control>
      </Form.Group>
    );
  }
  return '';
};

VideoDrawLineField.propTypes = {
  coordinatesDataType: PropTypes.string.isRequired,
  buttonActive: PropTypes.bool.isRequired,
  toggleButtonSwitch: PropTypes.func.isRequired
};

export default VideoDrawLineField;
